import * as API from '@/services/API';

export default {
  get(id, options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/flights/${id}${query}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/flights/${query}`);
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/flights/search${query}`);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/flights`, data);
    } else {
      return API.apiClient.put(`/flights/${id}`, data);
    }
  },
  async delete(id) {
    return API.apiClient.delete(`/flights/${id}`);
  }
};
